import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from './../layout/default/default.component';
import { ShubhLagnostavAddComponent } from './shubh-lagnostav-add/shubh-lagnostav-add.component';
import { ShubhLagnostavListComponent } from './shubh-lagnostav-list/shubh-lagnostav-list.component';
const routes: Routes = [{
  path: '',
  component: DefaultComponent,
  children: [{ path: 'shubh-lagnostav-add', component: ShubhLagnostavAddComponent },
  { path: 'shubh-lagnostav-list', component: ShubhLagnostavListComponent },
  { path: 'shubh-lagnostav-edit/:news_id', component: ShubhLagnostavAddComponent }
  ]
}];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShubhLagnostavRoutingModule { }
